module.exports = __webpack_public_path__ + "img/official_gp.6017b827.png";